import ChangeEmergencyContactModalComponent from './change-emergency-contact.module'

export default ChangeEmergencyContactModalComponent
